import { useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../hooks/useApi";
import { ErrorState, Loading, PageHeader, Segmented } from "../components/common";
import { CheckIcon, checkState } from "../components/ProjectBits";
import { gbp } from "../lib/format";

const SHORT = ["Owner code", "Proforma vs current equity", "Return vs equity in", "Projected vs cashflow profit", "Profit date quarter", "Equity date quarter", "Cash after window", "No return yet"];

const tip = (c) => (typeof c.value === "number" ? gbp(c.value) : c.value === null || c.value === undefined ? "n/a" : String(c.value));

export default function Checks() {
  const { data, error, status, loading } = useApi("/checks");
  const [show, setShow] = useState("Flagged");
  if (loading && !data) return <Loading />;
  if (error && !data) return <ErrorState message={error} status={status} />;
  const rows = show === "Flagged" ? data.rows.filter((r) => r.flags) : data.rows;
  return (
    <div data-testid="checks-page">
      <PageHeader eyebrow="Checks engine" title="Checks"
        subtitle={<><span className="font-semibold text-primary" data-testid="checks-flagged-count">{data.flagged_count}</span> of {data.rows.length} projects have at least one flag. Tolerance £1.</>}
        actions={<Segmented options={["Flagged", "All"]} value={show} onChange={setShow} testid="checks-filter" />} />
      <div className="overflow-auto rounded-lg border bg-card grid-scroll max-h-[75vh]">
        <table className="dt w-full text-sm" data-testid="checks-table">
          <thead className="sticky top-0 z-10 bg-card shadow-[0_1px_0_hsl(var(--border))]">
            <tr className="text-left">
              <th className="px-3 py-2.5 text-xs font-semibold text-muted-foreground min-w-[240px]">Project</th>
              {SHORT.map((s, i) => <th key={s} title={data.labels[i]} className="px-2 py-2.5 text-center text-[11px] font-semibold text-muted-foreground min-w-[90px]">{s}</th>)}
              <th className="px-3 py-2.5 text-right text-xs font-semibold text-muted-foreground">Issues</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-b last:border-0 hover:bg-accent/60" data-testid={`checks-row-${r.ref}`}>
                <td className="px-3 py-2"><Link to={`/projects/${r.id}`} className="font-semibold hover:text-primary">{r.name}</Link><div className="text-xs text-muted-foreground">{r.partner_name}</div></td>
                {r.checks.map((c) => (
                  <td key={c.key} className="px-2 py-2 text-center" title={`${c.label}: ${tip(c)}`} data-state={checkState(c)} data-testid={`checks-cell-${r.ref}-${c.key}`}>
                    <span className="inline-flex"><CheckIcon state={checkState(c)} /></span>
                  </td>
                ))}
                <td className={`px-3 py-2 text-right font-figure font-bold ${r.flags ? "text-primary" : "text-muted-foreground"}`}>{r.flags}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
